<template>
  <div class="trans">
    <v-tabs fixed-tabs
      v-model="active_tab"
      color="transparent"
      slider-color="green"
      class="text-sm-center"
    >
      <v-tab
        v-for="tab of tabs"
        :key="tab.index"
        :to='tab.to'
      >
      {{tab.name}}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    active: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    active_tab: 0
  }),
  mounted () {
    this.active_tab = this.active
  }
}
</script>
